import React from "react";
import { PoolWorkspace } from "@/components/PoolWorkspace";

export default function VideoPool() {
  return <PoolWorkspace kind="video" />;
}
